import L from 'leaflet';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

function loadHikeSummarySidebar(hikeSummaryElement) {
  var mapContainer = null;
  var altitudeProfile = null;

  if (hikeSummaryElement.id === 'hikesummary' || hikeSummaryElement.id === 'main-hikesummary') {
    mapContainer = document.getElementById('mapid');
    altitudeProfile = document.getElementById("altitudeprofile");

    if (altitudeProfile !== null) {
      altitudeProfile.style.width='100%';
      altitudeProfile.style.height='100%';
      altitudeProfile.width  = altitudeProfile.offsetWidth;
      altitudeProfile.height = altitudeProfile.offsetHeight;
    }
  } else {
    const maps = hikeSummaryElement.getElementsByClassName('map');

    if (maps && maps.length > 0) {
      mapContainer = maps[0];
    } else {
      return;
    }
  }

  var container = L.DomUtil.get(mapContainer.id);
  if(container != null){
    container._leaflet_id = null;
  }

  var mymap = L.map(mapContainer.id, { fullscreenControl: true });

  function addTrackLayer(json) {
      var layer = L.geoJson(json, {
      onEachFeature: function (feature, layer) {
        if (feature.geometry.type == "Point") {
          layer.bindPopup(feature.properties.name);
        }
      },
      style: {
        color: '#ff5500',
        weight: 4,
        opacity: 0.4
    }});

    layer.addTo(mymap);

    mymap.fitBounds(layer.getBounds());
  }

  function getTrackIndex(json) {
    for (var i = 0; i < json.features.length; i++) {
      if (json.features[i].geometry.type == "MultiLineString" || json.features[i].geometry.type == "LineString") {
        return i;
      }
    }

    throw "Track index not found.";
  }

  function findExtrema(values) {
    var ascent = 0;
    var descent = 0;
    var maxX = values[values.length-1][2];
    var maxY = values[0][1];
    var minY = values[0][1];

    for (var i = 0; i < values.length; i++) {
      if (values[i][1] > maxY) {
        maxY = values[i][1];
      }

      if (values[i][1] < minY) {
        minY = values[i][1];
      }

      if (i > 1) {
        var dif = values[i][3] - values[i - 1][3];

        if (dif > 0) {
          ascent += dif;
        } else {
          descent -= dif;
        }
      }
    }

    if (maxY - minY < 100) {
      maxY = minY + 100;
    }

    return {
      ascent: ascent,
      descent: descent,
      maxX: maxX,
      maxY: maxY,
      minY: minY,
      dif: maxY - minY
    };
  }

  function getDefinitions(ctx) {
    var xOffset = 16;
    var yOffset = 20;
    var width = ctx.canvas.width - 2 * xOffset;
    var height = (ctx.canvas.height / 3) - 2 * yOffset;

    return {
      xOffset: xOffset,
      yOffset: yOffset,
      width: width,
      height: height,
      canvasWidth: ctx.canvas.width,
      canvasHeight: ctx.canvas.height
    }
  }

  function toNiceTime(time) {
      var decimals = time - Math.floor(time);
    var minutes = Math.floor(decimals * 0.6 * 100);

    return Math.floor(time) + ":" + (minutes < 10 ? "0" + minutes : minutes);
  }

  function toContextWidth(value, definitions, extrema) {
    return definitions.width * value / extrema.maxX;
  }

  function toContextHeight(value, definitions, extrema) {
    return definitions.height - definitions.height * (value - extrema.minY) / extrema.dif;
  }

  function drawBackground(ctx, definitions) {
    ctx.fillStyle = "#EEEEEE";
    ctx.fillRect(-definitions.xOffset, -definitions.yOffset, ctx.canvas.width, ctx.canvas.height/3+14);
  }

  function drawProfile(values, ctx, definitions, extrema) {
    ctx.strokeStyle="#000000";
    ctx.lineWidth = 2;
    ctx.moveTo(0, definitions.height);

    for (var index = 0; index < values.length; index++) {
      ctx.lineTo(toContextWidth(values[index][2], definitions, extrema), toContextHeight(values[index][1], definitions, extrema));
    }

    ctx.lineTo(definitions.width, definitions.height);
    ctx.stroke();
    ctx.fillStyle="#DDDDDD";
    ctx.fill();
  }

  function drawAltitudeLines(ctx, definitions, extrema) {
    var baseline = (Math.floor(extrema.minY/100+1))*100;

    ctx.font = "12px Arial";
    ctx.fillStyle = "#000000";

    const add = extrema.maxY - baseline <= 1000 ? 100 : 200;
    const textModulo = Math.round((extrema.maxY - baseline) / add / 4) + 1;
    var counter = 0;

    ctx.setLineDash([5, 5]);
    ctx.lineWidth = 1;
    ctx.strokeStyle="#22222255";

    while (baseline < extrema.maxY) {
      ctx.beginPath();
      var y1 = toContextHeight(baseline, definitions, extrema);
      
      if (counter%textModulo == 0) {
        ctx.fillText(baseline + "m", -definitions.xOffset, y1);
        ctx.strokeStyle="#22222255";
      } else {
        ctx.strokeStyle="#22222222";
      }
      
      ctx.moveTo(-definitions.xOffset + 40, y1);
      ctx.lineTo(definitions.canvasWidth, y1);
      ctx.stroke();

      baseline = baseline + add;
      counter++;
    }
    
    ctx.setLineDash([]);
    ctx.strokeStyle="#000000";
  }

  function snipAroundProfile(values, ctx, definitions, extrema) {
    ctx.beginPath();
    ctx.lineWidth = 0;

    ctx.moveTo(-definitions.xOffset, -definitions.yOffset);
    ctx.lineTo(-definitions.xOffset, definitions.height);
    ctx.lineTo(0, definitions.height);

    for (var index = 0; index < values.length; index++) {
      ctx.lineTo(toContextWidth(values[index][2], definitions, extrema), toContextHeight(values[index][1], definitions, extrema) - 1);
    }

    ctx.lineTo(definitions.width + definitions.xOffset, definitions.height);
    ctx.lineTo(definitions.width + definitions.xOffset, -definitions.yOffset);
    ctx.lineTo(-definitions.xOffset, -definitions.yOffset);

    ctx.fillStyle="#aedae6";
    ctx.fill();
  }

  function drawBorderAroundChart(ctx, definitions) {
    ctx.beginPath();
    ctx.rect(-definitions.xOffset, -definitions.yOffset, definitions.canvasWidth, definitions.height + definitions.yOffset);
    ctx.stroke();
  }

  function addImage(i, x, y, imagesToDraw, json){
    if (json.features[i].properties.type == "Food") {
      imagesToDraw.food.push({x:x, y:y});
    } else if (json.features[i].properties.type == "Summit") {
      imagesToDraw.summit.push({x:x, y:y});
    } else {
      imagesToDraw.other.push({x:x, y:y});
    }

    return imagesToDraw;
  }

  function drawPointsOfInterest(json, ctx, definitions, extrema) {
    var imagesToDraw = {
      food: [],
      summit: [],
      other: []
    }

    ctx.font = "12px Arial";
    ctx.fillStyle = "#000000";
    ctx.beginPath();

    var counter = 0;
    var lastTextEndX = -1000;
    var lastTextEndX2 = -1000;

    for (var i = 0; i < json.features.length; i++) {
      if (json.features[i].geometry.type == "Point") {
        var x = toContextWidth(json.features[i].destination[2], definitions, extrema);
        var y = toContextHeight(json.features[i].destination[1], definitions, extrema);

        imagesToDraw = addImage(i, x, y, imagesToDraw, json);

        // write time under dashed line
        var time = toNiceTime(json.features[i].destination[0]);

        ctx.textAlign = "center";
        var textWidth = ctx.measureText(time).width;
        var textMeasureX = x - textWidth;

        if (textMeasureX > lastTextEndX) {
          ctx.fillText(time, x, definitions.height + 16);
          lastTextEndX = textMeasureX + textWidth;

          ctx.moveTo(x,y);
          ctx.lineTo(x,definitions.height);
        } else if (textMeasureX > lastTextEndX2) {
          ctx.fillText(time, x, definitions.height + 28);
          lastTextEndX2 = textMeasureX + textWidth;

          // dashed line
          ctx.moveTo(x,y);
          ctx.lineTo(x,definitions.height +  16);
        }

        // write time and POI in table
        var tableOffset = 48;
        var yText = definitions.height + tableOffset + counter * 20 - 1;

        if (counter%2 == 0) {
          ctx.fillStyle = "#DDDDDD";
        } else {
          ctx.fillStyle = "#EEEEEE";
        }

        ctx.fillRect(-definitions.xOffset, definitions.height + tableOffset + 4 + (counter-1)*20, definitions.canvasWidth, 20);

        ctx.fillStyle = "#000000";
        ctx.fillText(time, 0, yText);

        ctx.textAlign = "left";
        ctx.fillText(hikesummaryData && hikesummaryData.waypoints ? hikesummaryData.waypoints[i] : json.features[i].properties.name, 44, yText);
        imagesToDraw = addImage(i, 28, yText + 7, imagesToDraw, json);

        counter = counter + 1;
      }
    }

    // dashed line
    ctx.lineWidth = 1;
    ctx.setLineDash([5, 5]);
    ctx.stroke();

    // images to POI
    var food = new Image();
    food.onload = function() {
      for (var i = 0; i < imagesToDraw.food.length; i++) {
        ctx.drawImage(food, imagesToDraw.food[i].x - 8, imagesToDraw.food[i].y - 20, 16, 16);
      }
    }

    food.src = "/wp-content/uploads/trackinfo/noun_13105.svg";

    ctx.beginPath();

    for (var i = 0; i < imagesToDraw.summit.length; i++) {
      ctx.moveTo(imagesToDraw.summit[i].x, imagesToDraw.summit[i].y - 20);
      ctx.lineTo(imagesToDraw.summit[i].x, imagesToDraw.summit[i].y - 4);
      ctx.moveTo(imagesToDraw.summit[i].x - 3, imagesToDraw.summit[i].y - 16);
      ctx.lineTo(imagesToDraw.summit[i].x + 3, imagesToDraw.summit[i].y - 16);
    }

    ctx.setLineDash([]);
    ctx.stroke();

    var other = new Image();
    other.onload = function() {
      for (var i = 0; i < imagesToDraw.other.length; i++) {
        ctx.drawImage(other, imagesToDraw.other[i].x - 8, imagesToDraw.other[i].y - 20, 16, 16);
      }
    }

    other.src = "/wp-content/uploads/trackinfo/noun_201299.svg";
  }

  function draw(ctx, definitions, extrema, values, json) {
    ctx.translate(definitions.xOffset, definitions.yOffset);

    drawBackground(ctx, definitions);
    drawProfile(values, ctx, definitions, extrema);
    snipAroundProfile(values, ctx, definitions, extrema);
    drawAltitudeLines(ctx, definitions, extrema);
    drawBorderAroundChart(ctx, definitions);
    drawPointsOfInterest(json, ctx, definitions, extrema);
  }

  function drawAltitudeProfile(json, altitudeProfile) {
    addTrackLayer(json);

    if (altitudeProfile === undefined) {
      return;
    }

    var trackIndex = getTrackIndex(json);
    var values = json.features[trackIndex].altitudeProfile;
    var extrema = findExtrema(values);
    var ctx = altitudeProfile.getContext("2d");
    
    if (!altitudeProfile.getAttribute("initialheight")) {
      altitudeProfile.setAttribute("initialheight", altitudeProfile.height);
    } else {
      altitudeProfile.height = Number(altitudeProfile.getAttribute("initialheight"));
    }
    
    var definitions = getDefinitions(ctx);

    altitudeProfile.height =
      definitions.height +
      definitions.yOffset +
      28 + // times
      json.features.length * 20; // points

    if (window.devicePixelRatio && !altitudeProfile.getAttribute("scaled")) {
      var hidefCanvas = altitudeProfile;
      var hidefContext = hidefCanvas.getContext('2d');
      var hidefCanvasWidth = hidefCanvas.width;
      var hidefCanvasHeight = hidefCanvas.height;
  
      hidefCanvas.width = hidefCanvasWidth * window.devicePixelRatio;
      hidefCanvas.height = hidefCanvasHeight * window.devicePixelRatio;
      hidefCanvas.style.width = hidefCanvasWidth;
      hidefCanvas.style.height = hidefCanvasHeight;
      hidefContext.scale(window.devicePixelRatio, window.devicePixelRatio);
      altitudeProfile.setAttribute("scaled", window.devicePixelRatio);
    }
    
    const niceTime = hikesummaryData && hikesummaryData.duration
      ? toNiceTime(hikesummaryData.duration) + "h"
      : toNiceTime(values[values.length-1][0]) + "h";
    
    const ziel = hikesummaryData && hikesummaryData.end
      ? hikesummaryData.end
      : json.summary.ziel
        ? json.summary.ziel
        : hikesummaryData && hikesummaryData.start
          ? hikesummaryData.start
          : '-';
    
    document.getElementById("hikesummary-start").innerHTML = "<strong>Start</strong> " + (hikesummaryData && hikesummaryData.start ? hikesummaryData.start : json.summary.start);
    document.getElementById("hikesummary-ziel").innerHTML = "<strong>Ziel</strong> " + ziel;
    
    const huts = hikesummaryData && hikesummaryData.huts ? hikesummaryData.huts : json?.summary?.huts;
    if (huts) {
      document.getElementById("hikesummary-huts").innerHTML = huts ? "<strong>Einkehrmöglichkeiten</strong> " + huts : '';
    } else if (document.getElementById("hikesummary-huts")) {
      document.getElementById("hikesummary-huts").remove();
    }
    
    console.log(hikesummaryData);
    document.getElementById("hikesummary-anforderungen").innerHTML = "<strong>Anforderungen</strong> " + (hikesummaryData && hikesummaryData.requirements ? hikesummaryData.requirements : json.summary.anforderungen);
    
    const equipment = hikesummaryData && hikesummaryData.equipment ? hikesummaryData.equipment : json?.summary?.equipment;
    if (equipment) {
      document.getElementById("hikesummary-equipment").innerHTML = equipment ? "<strong>Ausrüstung</strong> " + equipment : '';
    } else if (document.getElementById("hikesummary-equipment")) {
      document.getElementById("hikesummary-equipment").remove();
    }

    document.getElementById("hikesummary-dauer").innerHTML = "<strong>Dauer</strong> " + niceTime;
    document.getElementById("hikesummary-distanz").innerHTML = "<strong>Distanz</strong> " + (hikesummaryData && hikesummaryData.distance ? Math.floor(hikesummaryData.distance / 100) / 10 + "km" : "-");
    document.getElementById("hikesummary-aufstieg").innerHTML = "<strong>Aufstieg</strong> " + Math.floor(hikesummaryData && hikesummaryData.ascend ? hikesummaryData.ascend : extrema.ascent) + "m";
    document.getElementById("hikesummary-abstieg").innerHTML = "<strong>Abstieg</strong> " + Math.floor(hikesummaryData && hikesummaryData.descend ? hikesummaryData.descend : extrema.descent) + "m";

    var route = "";
    const waypoints = hikesummaryData && hikesummaryData.waypoints ? hikesummaryData.waypoints : undefined;
    
    if (waypoints) {
      route = waypoints.join(' - ');
    } else {
      for (var i = 0; i < json.features.length; i++) {
        if (json.features[i].geometry.type == "Point") {
          route += json.features[i].properties.name + " - ";
        }
      }

      route = route.substring(0, route.length-3);
    }

    document.getElementById("hikesummary-wegverlauf").innerHTML = "<strong>Wegverlauf</strong> " + route;

    draw(ctx, definitions, extrema, values, json);
  }

  if (altitudeProfile !== null) {
    fetch(altitudeProfile.getAttribute("data"))
    .then(res => res.json())
    .then(json => drawAltitudeProfile(json, altitudeProfile));
  } else {
    fetch(mapContainer.getAttribute("data"))
    .then(res => res.json())
    .then(json => drawAltitudeProfile(json));
  }
  

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 18,
            attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, ' +
                '<a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
                'Imagery © <a href="http://mapbox.com">Mapbox</a>',
            id: 'mapbox.streets'
        }).addTo(mymap);
}

if (typeof LazyLoad == 'undefined') {
  !function(n,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(n="undefined"!=typeof globalThis?globalThis:n||self).LazyLoad=t()}(this,function(){"use strict";function n(){return(n=Object.assign||function(n){for(var t=1;t<arguments.length;t++){var e=arguments[t];for(var i in e)Object.prototype.hasOwnProperty.call(e,i)&&(n[i]=e[i])}return n}).apply(this,arguments)}var t="undefined"!=typeof window,e=t&&!("onscroll"in window)||"undefined"!=typeof navigator&&/(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent),i=t&&"IntersectionObserver"in window,a=t&&"classList"in document.createElement("p"),r=t&&window.devicePixelRatio>1,o={elements_selector:".lazy",container:e||t?document:null,threshold:300,thresholds:null,data_src:"src",data_srcset:"srcset",data_sizes:"sizes",data_bg:"bg",data_bg_hidpi:"bg-hidpi",data_bg_multi:"bg-multi",data_bg_multi_hidpi:"bg-multi-hidpi",data_bg_set:"bg-set",data_poster:"poster",class_applied:"applied",class_loading:"loading",class_loaded:"loaded",class_error:"error",class_entered:"entered",class_exited:"exited",unobserve_completed:!0,unobserve_entered:!1,cancel_on_exit:!0,callback_enter:null,callback_exit:null,callback_applied:null,callback_loading:null,callback_loaded:null,callback_error:null,callback_finish:null,callback_cancel:null,use_native:!1,restore_on_error:!1},c=function t(e){return n({},o,e)},l=function n(t,e){var i,a="LazyLoad::Initialized",r=new t(e);try{i=new CustomEvent(a,{detail:{instance:r}})}catch(o){(i=document.createEvent("CustomEvent")).initCustomEvent(a,!1,!1,{instance:r})}window.dispatchEvent(i)},s="srcset",u="sizes",f="poster",d="llOriginalAttrs",v="data",g="loading",b="loaded",p="applied",h="error",m="native",E="data-",I="ll-status",y=function n(t,e){return t.getAttribute(E+e)},k=function n(t,e,i){var a=E+e;if(null===i){t.removeAttribute(a);return}t.setAttribute(a,i)},A=function n(t){return y(t,I)},L=function n(t,e){return k(t,I,e)},O=function n(t){return L(t,null)},x=function n(t){return null===A(t)},C=function n(t){return A(t)===m},_=[g,b,p,h],N=function n(t,e,i,a){if(t){if(void 0!==a){t(e,i,a);return}if(void 0!==i){t(e,i);return}t(e)}},$=function n(t,e){if(a){t.classList.add(e);return}t.className+=(t.className?" ":"")+e},M=function n(t,e){if(a){t.classList.remove(e);return}t.className=t.className.replace(RegExp("(^|\\s+)"+e+"(\\s+|$)")," ").replace(/^\s+/,"").replace(/\s+$/,"")},z=function n(t){t.llTempImage=document.createElement("IMG")},R=function n(t){delete t.llTempImage},T=function n(t){return t.llTempImage},w=function n(t,e){if(e){var i=e._observer;i&&i.unobserve(t)}},G=function n(t){t.disconnect()},D=function n(t,e,i){e.unobserve_entered&&w(t,i)},V=function n(t,e){t&&(t.loadingCount+=e)},F=function n(t){t&&(t.toLoadCount-=1)},H=function n(t,e){t&&(t.toLoadCount=e)},j=function n(t){for(var e,i=[],a=0;e=t.children[a];a+=1)"SOURCE"===e.tagName&&i.push(e);return i},B=function n(t,e){var i=t.parentNode;i&&"PICTURE"===i.tagName&&j(i).forEach(e)},J=function n(t,e){j(t).forEach(e)},P=["src"],S=["src",f],U=["src",s,u],q=[v],K=function n(t){return!!t[d]},Q=function n(t){return t[d]},W=function n(t){return delete t[d]},X=function n(t,e){if(!K(t)){var i={};e.forEach(function(n){i[n]=t.getAttribute(n)}),t[d]=i}},Y=function n(t){!K(t)&&(t[d]={backgroundImage:t.style.backgroundImage})},Z=function n(t,e,i){if(!i){t.removeAttribute(e);return}t.setAttribute(e,i)},nn=function n(t,e){if(K(t)){var i=Q(t);e.forEach(function(n){Z(t,n,i[n])})}},nt=function n(t){if(K(t)){var e=Q(t);t.style.backgroundImage=e.backgroundImage}},ne=function n(t,e,i){$(t,e.class_applied),L(t,p),i&&(e.unobserve_completed&&w(t,e),N(e.callback_applied,t,i))},ni=function n(t,e,i){$(t,e.class_loading),L(t,g),i&&(V(i,1),N(e.callback_loading,t,i))},na=function n(t,e,i){i&&t.setAttribute(e,i)},nr=function n(t,e){na(t,u,y(t,e.data_sizes)),na(t,s,y(t,e.data_srcset)),na(t,"src",y(t,e.data_src))},no=function n(t,e,i){var a=y(t,e.data_bg),o=y(t,e.data_bg_hidpi),c=r&&o?o:a;c&&(t.style.backgroundImage='url("'.concat(c,'")'),T(t).setAttribute("src",c),ni(t,e,i))},nc=function n(t,e,i){var a=y(t,e.data_bg_multi),o=y(t,e.data_bg_multi_hidpi),c=r&&o?o:a;c&&(t.style.backgroundImage=c,ne(t,e,i))},nl=function n(t,e,i){var a=y(t,e.data_bg_set);if(a){var r=a.split("|"),o=r.map(function(n){return"image-set(".concat(n,")")});t.style.backgroundImage=o.join(),""===t.style.backgroundImage&&(o=r.map(function(n){return"-webkit-image-set(".concat(n,")")}),t.style.backgroundImage=o.join()),ne(t,e,i)}},ns={IMG:function n(t,e){B(t,function(n){X(n,U),nr(n,e)}),X(t,U),nr(t,e)},IFRAME:function n(t,e){X(t,P),na(t,"src",y(t,e.data_src))},VIDEO:function n(t,e){J(t,function(n){X(n,P),na(n,"src",y(n,e.data_src))}),X(t,S),na(t,f,y(t,e.data_poster)),na(t,"src",y(t,e.data_src)),t.load()},OBJECT:function n(t,e){X(t,q),na(t,v,y(t,e.data_src))}},nu=function n(t,e){var i=ns[t.tagName];i&&i(t,e)},nf=function n(t,e,i){var a=ns[t.tagName];a&&(a(t,e),ni(t,e,i))},nd=["IMG","IFRAME","VIDEO","OBJECT"],n8=function n(t,e){var i,a;e&&!((i=e).loadingCount>0)&&!((a=e).toLoadCount>0)&&N(t.callback_finish,e)},nv=function n(t,e,i){t.addEventListener(e,i),t.llEvLisnrs[e]=i},ng=function n(t,e,i){t.removeEventListener(e,i)},nb=function n(t){return!!t.llEvLisnrs},np=function n(t,e,i){nb(t)||(t.llEvLisnrs={});var a="VIDEO"===t.tagName?"loadeddata":"load";nv(t,a,e),nv(t,"error",i)},nh=function n(t){if(nb(t)){var e=t.llEvLisnrs;for(var i in e){var a=e[i];ng(t,i,a)}delete t.llEvLisnrs}},nm=function n(t,e,i){R(t),V(i,-1),F(i),M(t,e.class_loading),e.unobserve_completed&&w(t,i)},nE=function n(t,e,i,a){var r=C(e);nm(e,i,a),$(e,i.class_loaded),L(e,b),N(i.callback_loaded,e,a),r||n8(i,a)},nI=function n(t,e,i,a){var r=C(e);nm(e,i,a),$(e,i.class_error),L(e,h),N(i.callback_error,e,a),i.restore_on_error&&nn(e,U),r||n8(i,a)},ny=function n(t,e,i){var a=T(t)||t;if(!nb(a)){var r=function n(r){nE(r,t,e,i),nh(a)},o=function n(r){nI(r,t,e,i),nh(a)};np(a,r,o)}},nk=function n(t,e,i){z(t),ny(t,e,i),Y(t),no(t,e,i),nc(t,e,i),nl(t,e,i)},nA=function n(t,e,i){ny(t,e,i),nf(t,e,i)},nL=function n(t,e,i){var a;(a=t,nd.indexOf(a.tagName)>-1)?nA(t,e,i):nk(t,e,i)},nO=function n(t,e,i){t.setAttribute("loading","lazy"),ny(t,e,i),nu(t,e),L(t,m)},nx=function n(t){t.removeAttribute("src"),t.removeAttribute(s),t.removeAttribute(u)},nC=function n(t){B(t,function(n){nx(n)}),nx(t)},n_=function n(t){B(t,function(n){nn(n,U)}),nn(t,U)},nN={IMG:n_,IFRAME:function n(t){nn(t,P)},VIDEO:function n(t){J(t,function(n){nn(n,P)}),nn(t,S),t.load()},OBJECT:function n(t){nn(t,q)}},n$=function n(t){var e=nN[t.tagName];if(!e){nt(t);return}e(t)},nM=function n(t,e){!(x(t)||C(t))&&(M(t,e.class_entered),M(t,e.class_exited),M(t,e.class_applied),M(t,e.class_loading),M(t,e.class_loaded),M(t,e.class_error))},nz=function n(t,e){n$(t),nM(t,e),O(t),W(t)},nR=function n(t,e,i,a){var r;if(i.cancel_on_exit)A(r=t)===g&&"IMG"===t.tagName&&(nh(t),nC(t),n_(t),M(t,i.class_loading),V(a,-1),O(t),N(i.callback_cancel,t,e,a))},nT=function n(t,e,i,a){var r,o=(r=t,_.indexOf(A(r))>=0);L(t,"entered"),$(t,i.class_entered),M(t,i.class_exited),D(t,i,a),N(i.callback_enter,t,e,a),o||nL(t,i,a)},nw=function n(t,e,i,a){x(t)||($(t,i.class_exited),nR(t,e,i,a),N(i.callback_exit,t,e,a))},nG=["IMG","IFRAME","VIDEO"],nD=function n(t){return t.use_native&&"loading"in HTMLImageElement.prototype},nV=function n(t,e,i){t.forEach(function(n){-1!==nG.indexOf(n.tagName)&&nO(n,e,i)}),H(i,0)},nF=function n(t,e,i){t.forEach(function(n){var t;return(t=n).isIntersecting||t.intersectionRatio>0?nT(n.target,n,e,i):nw(n.target,n,e,i)})},nH=function n(t,e){e.forEach(function(n){t.observe(n)})},nj=function n(t,e){G(t),nH(t,e)},nB=function n(t,e){var a;!(!i||nD(t))&&(e._observer=new IntersectionObserver(function(n){nF(n,t,e)},{root:(a=t).container===document?null:a.container,rootMargin:a.thresholds||a.threshold+"px"}))},nJ=function n(t){return Array.prototype.slice.call(t)},nP=function n(t){return t.container.querySelectorAll(t.elements_selector)},nS=function n(t){var e;return A(e=t)===h},nU=function n(t,e){var i;return i=t||nP(e),nJ(i).filter(x)},n9=function n(t,e){var i;(i=nP(t),nJ(i).filter(nS)).forEach(function(n){M(n,t.class_error),O(n)}),e.update()},nq=function n(e,i){t&&(i._onlineHandler=function(){n9(e,i)},window.addEventListener("online",i._onlineHandler))},n1=function n(e){t&&window.removeEventListener("online",e._onlineHandler)},nK=function n(t,e){var i=c(t);this._settings=i,this.loadingCount=0,nB(i,this),nq(i,this),this.update(e)};return nK.prototype={update:function n(t){var a=this._settings,r=nU(t,a);if(H(this,r.length),e||!i){this.loadAll(r);return}if(nD(a)){nV(r,a,this);return}nj(this._observer,r)},destroy:function n(){this._observer&&this._observer.disconnect(),n1(this),nP(this._settings).forEach(function(n){W(n)}),delete this._observer,delete this._settings,delete this._onlineHandler,delete this.loadingCount,delete this.toLoadCount},loadAll:function n(t){var e=this,i=this._settings;nU(t,i).forEach(function(n){w(n,e),nL(n,i,e)})},restoreAll:function n(){var t=this._settings;nP(t).forEach(function(n){nz(n,t)})}},nK.load=function(n,t){var e=c(t);nL(n,e)},nK.resetStatus=function(n){O(n)},t&&function n(t,e){if(e){if(e.length)for(var i,a=0;i=e[a];a+=1)l(t,i);else l(t,e)}}(nK,window.lazyLoadOptions),nK});
}

if (document.body.clientWidth <= 768) {
  new LazyLoad({
    elements_selector: "#main-hikesummary",
    callback_enter: loadHikeSummarySidebar
  });

  const sidebar = document.getElementsByClassName('sidebar-hike-summary');

  if (sidebar && sidebar[0]) {
    sidebar[0].remove();
  }
  
} else {
  new LazyLoad({
    elements_selector: "#hikesummary",
    callback_enter: loadHikeSummarySidebar
  });

  const mainHikeSummary = document.getElementsByClassName('wp-block-alsnuff-hike-summary-mobile-block');

  if (mainHikeSummary && mainHikeSummary[0]) {
    mainHikeSummary[0].remove();
  }
}

new LazyLoad({
  elements_selector: ".hikesummary",
  callback_enter: loadHikeSummarySidebar
});

const hikeSummaries = document.getElementsByClassName("hike-summary-block");

Array.from(hikeSummaries).forEach(hikeSummary => {
  new LazyLoad({
    elements_selector: "#hike-container-" + hikeSummary.getAttribute("data-id"),
    callback_enter: loadHikeSummarySidebar
  });
});